import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth.js';
import logo from '../../assets/core-kiteboarding_logo.svg';

const Header = () => {
  const { logout, user } = useAuth();
    return (
  <header className="header">
    <a href="/" className="logo">
      <img src={logo} alt="CORE Logo" height="45" width="130" />
      <h1>SHAREPOINT-ORDNER ANLEGEN</h1>
    </a>
    <input type="checkbox" id="menu-toggle" className="menuToggle" />
    <label htmlFor="menu-toggle" className="menuIcon">
      <div className="bar bar1"></div>
      <div className="bar bar2"></div>
      <div className="bar bar3"></div>
    </label>
    <nav className="nav">
      <NavLink to="/" className={({ isActive }) => isActive ? "active" : ""}>
        HOME
      </NavLink>
      <NavLink to="/NewFolder/customer" className={({ isActive }) => isActive ? "active" : ""}>
        NEUER KUNDENORDNER
      </NavLink>
      <NavLink to="/NewFolder/supplier" className={({ isActive }) => isActive ? "active" : ""}>
        NEUER LIEFERANTENORDNER
      </NavLink>
      <NavLink to="/NewFolder/product" className={({ isActive }) => isActive ? "active" : ""}>
        NEUER PRODUKTORDNER
      </NavLink>
      <button onClick={logout} className="logout-link">
        - LOGOUT {user?.name.toUpperCase()} -
      </button>
    </nav>
  </header>
    );
    };

export default Header;
